<template>
  <div class="color-explanation" >
    <div :class="['rectangle', mainColor]">
      <p v-html="title"></p>
      <div :class="['circle', secondaryColor]"></div>
    </div>
    <p v-html="body" class="text-below"></p>
  </div>
</template>

<script>
export default {
  name: 'ColorExplanation',
  props: ['title', 'body', 'mainColor', 'secondaryColor'],
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .color-explanation
    width: 30rem

    .rectangle
      box-sizing: border-box
      position: relative
      height: 45rem
      width: 100%
      padding: 2rem 0 0 3rem
      font-size: 4rem
      font-weight: 700
      color: $white

      p
        margin: 0
        max-width: 40rem

    .circle
      box-sizing: border-box
      position: absolute
      bottom: -7.5rem
      left: 25%
      height: 10rem
      width: 10rem
      margin: 1rem
      padding: 4rem
      border-radius: 100%
      outline: 5px solid $white

    .orange
      background-color: $primary-color

    .light-orange
      background-color: $secondary-color
      border: 2rem solid $primary-color

    .blue
      background-color: $blue

    .light-blue
      background-color: $blue30
      border: 2rem solid $blue

    .green
      background-color: $green

    .light-green
      background-color: $green30
      border: 2rem solid $green

    .text-below
      margin-top: 10rem
      padding: 0 1rem
      font-size: 1.5rem
      text-align: center
</style>
